import { render } from "./ClientRequestsBoard.vue?vue&type=template&id=4155c5bd&scoped=true&ts=true"
import script from "./ClientRequestsBoard.vue?vue&type=script&lang=ts"
export * from "./ClientRequestsBoard.vue?vue&type=script&lang=ts"

import "./ClientRequestsBoard.vue?vue&type=style&index=0&id=4155c5bd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4155c5bd"]])

export default __exports__